module.exports = __webpack_public_path__ + "assets/img/650200.135b23c6.png";